import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-market-icon-orange",
  "use": "icon-market-icon-orange-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-market-icon-orange\">\n<path d=\"M7 0L0 3.20974V14H4.69843V8.70107H9.30157V14H14V3.20974L7 0Z\" fill=\"#F7B966\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol